import * as io from "io-ts";
import { Column, Identifier } from "diagnostics-domain/dashboard/type";
/** @note allow empty string for templating */
export const Encoding = io.intersection([
  io.type({
    identifier: io.union([Identifier, io.refinement(io.string, s => s.length === 0)]),
    column: io.union([Column, io.refinement(io.string, s => s.length === 0)]),
  }),
  io.partial({
    quantity: io.union([Identifier, io.undefined]),
  }),
]);

/** @note allow empty string for templating */
export const DiagramEncoding = io.intersection([
  io.type({
    identifier: io.union([Identifier, io.refinement(io.string, s => s.length === 0)]),
    column: io.union([Column, io.refinement(io.string, s => s.length === 0), io.null]),
  }),
  io.partial({
    quantity: io.union([Identifier, io.undefined]),
  }),
]);
export type EncodingT = io.TypeOf<typeof Encoding>;
export type DiagramEncodingT = io.TypeOf<typeof DiagramEncoding>;
